// extracted by mini-css-extract-plugin
export default {"StoreInfo":"StoreInfo-styles__StoreInfo__BTcqg"};